import { ImageIcon } from "lucide-react";

import { cn } from "@/lib/utils";

// 사진 자리 색 — 외부 이미지 없이 토큰 색 칸으로 현장 사진을 대신한다.
const TONES = [
  "bg-status-done-bg text-status-done",
  "bg-status-progress-bg text-status-progress",
  "bg-accent text-accent-foreground",
  "bg-status-new-bg text-status-new",
  "bg-muted text-muted-foreground",
] as const;

const DemoPhoto = ({ caption, index }: { caption: string; index: number }) => (
  <div
    aria-label={`${caption} (데모 사진 자리)`}
    className={cn("flex aspect-square w-full flex-col items-center justify-center gap-1 rounded-md p-1 text-center", TONES[index % TONES.length])}
    role="img">
    <ImageIcon aria-hidden className="size-5" />
    <span className="line-clamp-2 text-xs">{caption}</span>
  </div>
);

export default DemoPhoto;
